import * as React from "react";
import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

export interface PanelSectionHeaderProps {
  icon?: LucideIcon;
  title: string;
  /** Shown when count > 0, e.g. count={3} countLabel="blocks" → "3 blocks" */
  count?: number;
  countLabel?: string;
  trailing?: React.ReactNode;
  className?: string;
}

export function PanelSectionHeader({
  icon: Icon,
  title,
  count,
  countLabel = "items",
  trailing,
  className,
}: PanelSectionHeaderProps) {
  const showCount = count !== undefined && count > 0;

  return (
    <div
      className={cn(
        "flex shrink-0 items-center justify-between gap-3 border-b border-slate-200/80 pb-3",
        className
      )}
    >
      <div className="flex min-w-0 items-center gap-2.5">
        {Icon ? <Icon className="h-5 w-5 shrink-0 text-slate-500" strokeWidth={2} aria-hidden /> : null}
        <h2 className="m-0 truncate text-sm font-semibold tracking-tight text-slate-900">{title}</h2>
        {showCount ? (
          <span className="shrink-0 text-xs font-normal text-slate-500">
            {count} {count === 1 ? countLabel.replace(/s$/, "") : countLabel}
          </span>
        ) : null}
      </div>
      {trailing ? <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">{trailing}</div> : null}
    </div>
  );
}
